export function maskEmail(email: string): string {
  const [localPart, domain] = email.split('@')
  if (!domain) {
    return email
  }

  const visible = localPart.slice(0, 1)
  return `${visible}***@${domain}`
}
